import { BehaviorSubject } from 'rxjs';

import LoginWorkspacesDialog from '../components/login/LoginWorkspacesDialog';
import LoginException from '../exceptions/LoginException';

export default class LoginBloc {
  isLoggingIn$ = new BehaviorSubject(false);
  isShowOverlay$ = new BehaviorSubject(false);
  userWorkspaces$ = new BehaviorSubject([]);

  constructor({ authRepository, userRepository, patientRepository, dialogRepository }) {
    this.authRepository = authRepository;
    this.userRepository = userRepository;
    this.patientRepository = patientRepository;
    this.dialogRepository = dialogRepository;
  }

  async login(username, password, recaptchaToken) {
    this.userRepository.setIsPatientDashboardTourShown(1);
    this.userRepository.removeShouldRunSelfHelpJoyride();
    this.userRepository.removeIsPatientDemoAccount();

    this.isLoggingIn$.next(true);
    try {
      const result = await this.authRepository.login(username, password, recaptchaToken);
      if (result?.workspaces?.length) {
        const isMediphanyWorkspace = this.isMediphanyWorkspace$.getValue();
        if (!isMediphanyWorkspace) throw new LoginException({ message: 'Incorrect email or password' });

        this.userWorkspaces$.next(result.workspaces);
        this.openWorkspacesDialog({ email: result.email, workspaces: result.workspaces });
      }
    } finally {
      this.isLoggingIn$.next(false);
    }
  }

  async loginToken(token, isDemo) {
    this.userRepository.setIsPatientDashboardTourShown(1);
    this.userRepository.removeShouldRunSelfHelpJoyride();
    this.userRepository.removeIsPatientDemoAccount();

    try {
      this.isShowOverlay$.next(true);
      await this.authRepository.loginToken(token);

      const profile = this.authRepository.auth$.getValue();
      if (profile && isDemo) {
        this.userRepository.removeIsPatientDashboardTourShown();
      }
    } finally {
      this.isShowOverlay$.next(false);
    }
  }

  async register(data) {
    await this.authRepository.register(data);
  }

  openWorkspacesDialog({ email, workspaces }) {
    this.dialogRepository.loadDialog(LoginWorkspacesDialog, { email, workspaces });
  }

  logout() {
    this.authRepository.logout();
    this.userRepository.removeIsPatientDashboardTourShown();
    this.userRepository.removeIsPatientDemoAccount();
  }

  get isMediphanyWorkspace$() {
    return this.authRepository.isMediphanyWorkspace$;
  }
}
